import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { ActivityShowDto } from "apiGen";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { activityKeys } from "~shared/api/activities/activityKeys";
import { webserviceApi } from "~shared/api/webserviceApi";

export interface IActivityFormState {
	name: ActivityShowDto["name"];
	description?: ActivityShowDto["description"];
}

const useValidate = () => {
	const { t } = useTranslation();

	return (values: IActivityFormState) => {
		const errors: { [K in keyof IActivityFormState]?: any } = {};

		if (!values.name) {
			errors.name = t("Field is required");
		}
		return errors;
	};
};

const ActivityDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="name" label={t("Name")} required />
			<TextField name="description" label={t("Description")} />
		</FormDrawerContent>
	);
};

const initialValues: IActivityFormState = {
	name: "",
	description: "",
};

export const ActivityCreateDrawer: FC<CreateDrawerFormProps<IActivityFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormDrawer
			{...drawerProps}
			initialValues={initialValues}
			title={t("Add activity")}
			validate={validate}
			renderForm={(props) => <ActivityDrawerContent {...props} />}
		/>
	);
};

export const ActivityUpdateDrawer: FC<UpdateDrawerFormProps<IActivityFormState>> = (drawerProps) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...drawerProps}
			queryFn={() => webserviceApi.showActivity(+drawerProps.id).then((x) => x.data.data)}
			queryKey={activityKeys.detail(drawerProps.id)}
			title={t("Edit activity")}
			validate={validate}
			renderSuccess={(props) => <ActivityDrawerContent {...props} />}
		/>
	);
};
